import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import { PopupButtonMessage } from 'components';
import { startTrial } from 'store/actionCreators/subscriptions';
import { ReactComponent as RocketLaunchIcon } from 'static/images/rocket_launch.svg';

import { BtnPrimary, InfoNote } from './styled';

type StartTrialControlProps = {
  errorMessage?: string | null;
};

const TrialStartButton = () => {
  const { t } = useTranslation();
  return (
    <BtnPrimary type="button">
      <RocketLaunchIcon width={18} height={18} aria-hidden />
      {t('subscriptions.startTrial')}
    </BtnPrimary>
  );
};

const StartTrialControl = ({ errorMessage }: StartTrialControlProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <>
      <PopupButtonMessage
        popupHeaderText={t('subscriptions.startTrialHeader')}
        popupMessageText={t('subscriptions.startTrialText')}
        popupButtonText={t('subscriptions.startTrialPopupButton')}
        ButtonComponent={TrialStartButton}
        onConfirm={() => dispatch(startTrial())}
      />
      {errorMessage ? <InfoNote role="alert">{errorMessage}</InfoNote> : null}
    </>
  );
};

export default StartTrialControl;
